export default "__VITE_ASSET__B9io$Pny__"